<div *ngIf="filterCfg?.inputs" class="filter-holder">
  <form>
    <div class="d-flex align-items-start">
      <div style="width: 50px; margin-right: 5px; flex-shrink: 0">
        <div class="filter-text">
          <span class="hld">
            <img
              *ngIf="!isFilterhasValue"
              src="./assets/images/filter-cp.png"
              alt="filter"
            />
            <img
              *ngIf="isFilterhasValue"
              class="cursor-pointer"
              title="Clear All"
              (click)="clearAllFilter()"
              src="./assets/images/clear-filter.png"
              alt="clear"
            />
          </span>
        </div>
      </div>
      <div
        #filterPillsContainer
        class="flex-grow-1 vscroll flex-wrap pb-0"
        [class.filters-collapsed]="exceedsTwoRows && (!isExpanded || isTransitioning)"
        [class.filters-expanded]="exceedsTwoRows && isExpanded && !isTransitioning"
        [style.maxHeight]="getContainerMaxHeight()"
        [style.overflow]="exceedsTwoRows && (!isExpanded || isTransitioning) ? 'hidden' : null"
      >
        <div *ngFor="let item of filterCfg?.inputs; let i = index"
             class="filter-pill"
             [ngClass]="'filter-color-' + (i % 5)">
          <div class="form-item mb-1" *ngIf="item.type === 'searchable-multiselect'">
            <app-searchable-multiselect
              [controlName]="item.field"
              [selectedValues]="item.value"
              [placeholderText]="item.placeholder"
              [options]="item.options"
              [isDisabled]="item.disabled"
              [width]="item.width"
              (multiSelectValues)="
                handleSearchableMultiSelectValue($event, item.field)
              "
            ></app-searchable-multiselect>
          </div>
          <div class="form-item mb-1" *ngIf="item.type === 'searchable-select'">
            <app-searchable-select
              [controlName]="item.field"
              [selectedValue]="item.value"
              [placeholderText]="item.placeholder"
              [options]="item.options"
              [isDisabled]="item.disabled"
              (selectValue)="handleSearchableSelectValue($event, item.field)"
            ></app-searchable-select>
          </div>
          <div class="form-item mb-1" *ngIf="item.type === 'input'">
            <app-input
              [controlName]="item.field"
              [selectedValue]="item.value"
              [placeholderText]="item.placeholder"
              (inputValue)="handleInputOrDateValue($event, item.field)"
              [width]="item.width"
            ></app-input>
          </div>
          <div class="form-item mb-1" *ngIf="item.type === 'datepicker'">
            <app-datepicker
              [controlName]="item.field"
              [placeholderText]="item.placeholder"
              (selectDate)="handleInputOrDateValue($event, item.field)"
            ></app-datepicker>
          </div>
        </div>
      </div>
      <!-- Expand/Collapse Toggle Button -->
      <div *ngIf="exceedsTwoRows" class="filter-toggle-wrapper">
        <button
          type="button"
          class="filter-toggle-btn"
          (click)="toggleExpand()"
          [matTooltip]="getToggleTooltip()"
          matTooltipPosition="below"
          [attr.aria-expanded]="isExpanded"
        >
          <span class="toggle-text">{{ isExpanded ? 'Show less' : 'Show more' }}</span>
          <span *ngIf="!isExpanded && hiddenFilterCount > 0" class="hidden-count">
            (+{{ hiddenFilterCount }})
          </span>
          <span
            *ngIf="!isExpanded && hiddenActiveFilterCount > 0"
            class="active-filter-badge"
            [title]="hiddenActiveFilterCount + ' active filter(s) in hidden rows'"
          >
            {{ hiddenActiveFilterCount }}
          </span>
          <mat-icon class="toggle-icon">{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>
